<template>
	<div class="el-col-sm-24" style="margin: 5px;">
		<md-switch v-model="useRetention" @change="onChange">
			<span :class="{'accent_color': useRetention}">
				{{ this.$t("label.option.all") }}
			</span>
		</md-switch>
	</div>
</template>
<script>

export default {
	data() {
		return {
			useRetention: false
		};
	},
	methods: {
		onChange() {
			this.params.api.forEachNode(rowNode => {
				let retentionRate = rowNode.data[this.params.retentionRateField];
				let isRetentionMandatory = rowNode.data[this.params.retentionMandatoryField];

				// Retention is only available if it was allowed by the seller, as indicated by an existing rate
				if (this.useRetention && !retentionRate) {
					return;
				}

				// Retention must be used if it is mandatory
				if (!this.useRetention && isRetentionMandatory) {
					return;
				}

				rowNode.data[this.params.useRetentionField] = this.useRetention;
			});
		}
	},
};
</script>